import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["className"],
  _excluded2 = ["render", "label"],
  _excluded3 = ["id", "tags", "theme", "max", "className"];
import _Array$from from "@babel/runtime-corejs2/core-js/array/from";
import * as React from 'react';
import clsx from 'clsx';
import DropDownContainer, { DropDown } from '../DropDown';
import { Base } from '../Base';
import Tag from '../Tag';
var styles = {
  "root": "TagList-root_23R5w",
  "list": "TagList-list_2vAuV",
  "item": "TagList-item_Y2w1A",
  "dropdown": "TagList-dropdown_2Ve-I"
};
function List(_ref) {
  var className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      tagName: "ul",
      flexInline: true,
      flexWrap: true,
      gap: "xxsmall",
      marginY: "none",
      paddingX: "none",
      listStyleType: "none",
      className: clsx(styles.list, className)
    }, extraProps))
  );
}
function renderTag(tag) {
  var render = tag.render,
    label = tag.label,
    rest = _objectWithoutProperties(tag, _excluded2);
  var tagElement = typeof render === 'function' ? render(tag) : /*#__PURE__*/React.createElement(Tag, rest, label);
  return /*#__PURE__*/React.createElement("li", {
    key: label,
    className: styles.item
  }, tagElement);
}
function More(_ref2) {
  var id = _ref2.id,
    tags = _ref2.tags,
    theme = _ref2.theme;
  return /*#__PURE__*/React.createElement("li", {
    className: styles.item
  }, /*#__PURE__*/React.createElement(DropDownContainer, {
    id: "".concat(id, "-dropdown"),
    placement: "bottom",
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 4]
      }
    }],
    renderReference: function renderReference(getReferenceProps) {
      return (
        /*#__PURE__*/
        // $FlowFixMe[cannot-spread-inexact]
        React.createElement(Tag, _extends({
          theme: theme
        }, getReferenceProps()), "+ ", tags.length)
      );
    }
  }, function (getDropDownProps) {
    return (
      /*#__PURE__*/
      // $FlowFixMe[cannot-spread-inexact]
      React.createElement(DropDown, _extends({
        paddingX: "xsmall",
        className: styles.dropdown
      }, getDropDownProps()), /*#__PURE__*/React.createElement(List, null, tags.map(renderTag)))
    );
  }));
}
function TagList(_ref3) {
  var id = _ref3.id,
    tags = _ref3.tags,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? 'grey' : _ref3$theme,
    max = _ref3.max,
    className = _ref3.className,
    extraProps = _objectWithoutProperties(_ref3, _excluded3);
  var hasTags = Array.isArray(tags) && tags.length > 0;
  var hasMore = typeof max === 'number' && hasTags && tags.length > max;
  if (!hasTags) {
    return null;
  }
  var all = _Array$from(tags, function (tag) {
    return _objectSpread({
      theme: theme
    }, tag);
  });
  var shown = all.slice(0, max);
  var more = all.slice(max);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(List, _extends({
      className: clsx(styles.root, className)
    }, extraProps), shown.map(renderTag), hasMore && /*#__PURE__*/React.createElement(More, {
      id: id,
      tags: more,
      theme: theme
    }))
  );
}
export default TagList;